module.exports = __webpack_public_path__ + "img/bizsafestar.b5f5f602.jpg";